//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import followIfLoginRedirect from './components/api-authorization/followIfLoginRedirect';

export class ApprovalsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    reviewPage(token: string): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/review?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReviewPage(_response);
        });
    }

    protected processReviewPage(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processApproval(request: ApprovalDecisionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessApproval(_response);
        });
    }

    protected processProcessApproval(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reviewItemApprovalPage(token: string): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/review-item?";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined and cannot be null.");
        else
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReviewItemApprovalPage(_response);
        });
    }

    protected processReviewItemApprovalPage(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    processItemApproval(request: ApprovalDecisionRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/process-item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessItemApproval(_response);
        });
    }

    protected processProcessItemApproval(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resendApprovalEmail(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/resend/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResendApprovalEmail(_response);
        });
    }

    protected processResendApprovalEmail(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resendItemApprovalEmail(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/resend-item/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processResendItemApprovalEmail(_response);
        });
    }

    protected processResendItemApprovalEmail(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    requestNewApprovalLink(request: RequestNewLinkRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/approvals/request-new-link";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRequestNewApprovalLink(_response);
        });
    }

    protected processRequestNewApprovalLink(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DashboardClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDashboardData(userEmail: string | null | undefined, department: string | null | undefined, role: string | null | undefined): Promise<DashboardDataDto> {
        let url_ = this.baseUrl + "/api/dashboard?";
        if (userEmail !== undefined && userEmail !== null)
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (role !== undefined && role !== null)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDashboardData(_response);
        });
    }

    protected processGetDashboardData(response: Response): Promise<DashboardDataDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardDataDto>(null as any);
    }

    getMyTasks(userEmail: string | null, userIdentityId: string | null | undefined, userId: number | null | undefined, teamIds: string | null | undefined): Promise<MyTasksDashboardDto> {
        let url_ = this.baseUrl + "/api/dashboard/my-tasks?";
        if (userEmail === undefined)
            throw new Error("The parameter 'userEmail' must be defined.");
        else if(userEmail !== null)
            url_ += "UserEmail=" + encodeURIComponent("" + userEmail) + "&";
        if (userIdentityId !== undefined && userIdentityId !== null)
            url_ += "UserIdentityId=" + encodeURIComponent("" + userIdentityId) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (teamIds !== undefined && teamIds !== null)
            url_ += "TeamIds=" + encodeURIComponent("" + teamIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMyTasks(_response);
        });
    }

    protected processGetMyTasks(response: Response): Promise<MyTasksDashboardDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MyTasksDashboardDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MyTasksDashboardDto>(null as any);
    }
}

export class DebugClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCurrentUserDebug(): Promise<void> {
        let url_ = this.baseUrl + "/api/debug/current-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCurrentUserDebug(_response);
        });
    }

    protected processGetCurrentUserDebug(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DepartmentsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getDepartments(locationId: number | null | undefined): Promise<DepartmentDto[]> {
        let url_ = this.baseUrl + "/api/departments?";
        if (locationId !== undefined && locationId !== null)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDepartments(_response);
        });
    }

    protected processGetDepartments(response: Response): Promise<DepartmentDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepartmentDto[]>(null as any);
    }

    createDepartment(command: CreateDepartmentCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/departments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDepartment(_response);
        });
    }

    protected processCreateDepartment(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateDepartment(id: number, command: UpdateDepartmentCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/departments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateDepartment(_response);
        });
    }

    protected processUpdateDepartment(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteDepartment(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/departments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDepartment(_response);
        });
    }

    protected processDeleteDepartment(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmployeesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getEmployees(department: string | null | undefined, isActive: boolean | null | undefined, isDraft: boolean | null | undefined): Promise<EmployeeDto[]> {
        let url_ = this.baseUrl + "/api/employees?";
        if (department !== undefined && department !== null)
            url_ += "Department=" + encodeURIComponent("" + department) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isDraft !== undefined && isDraft !== null)
            url_ += "IsDraft=" + encodeURIComponent("" + isDraft) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: Response): Promise<EmployeeDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeDto[]>(null as any);
    }

    createEmployee(command: CreateEmployeeCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateEmployee(_response);
        });
    }

    protected processCreateEmployee(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getEmployeeById(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmployeeById(_response);
        });
    }

    protected processGetEmployeeById(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateEmployee(id: number, command: UpdateEmployeeCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    checkEmailExists(email: string): Promise<void> {
        let url_ = this.baseUrl + "/api/employees/check-email?";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined and cannot be null.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckEmailExists(_response);
        });
    }

    protected processCheckEmailExists(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    previewImport(file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/employees/import/preview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPreviewImport(_response);
        });
    }

    protected processPreviewImport(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    executeImport(createMissingEntities: boolean | undefined, file: FileParameter | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/employees/import/execute?";
        if (createMissingEntities === null)
            throw new Error("The parameter 'createMissingEntities' cannot be null.");
        else if (createMissingEntities !== undefined)
            url_ += "createMissingEntities=" + encodeURIComponent("" + createMissingEntities) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExecuteImport(_response);
        });
    }

    protected processExecuteImport(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LocationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getLocations(): Promise<LocationDto[]> {
        let url_ = this.baseUrl + "/api/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<LocationDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto[]>(null as any);
    }

    createLocation(command: CreateLocationCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateLocation(id: number, command: UpdateLocationCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteLocation(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OffboardingRequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getOffboardingRequests(): Promise<OffboardingRequestDto[]> {
        let url_ = this.baseUrl + "/api/offboardingrequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOffboardingRequests(_response);
        });
    }

    protected processGetOffboardingRequests(response: Response): Promise<OffboardingRequestDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OffboardingRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OffboardingRequestDto[]>(null as any);
    }

    getOffboardingRequestDetails(id: number): Promise<OffboardingRequestDetailsDto> {
        let url_ = this.baseUrl + "/api/offboardingrequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOffboardingRequestDetails(_response);
        });
    }

    protected processGetOffboardingRequestDetails(response: Response): Promise<OffboardingRequestDetailsDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OffboardingRequestDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OffboardingRequestDetailsDto>(null as any);
    }

    deleteOffboardingRequest(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteOffboardingRequest(_response);
        });
    }

    protected processDeleteOffboardingRequest(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    initializeOffboardingPreview(employeeId: number): Promise<OffboardingPreviewDto> {
        let url_ = this.baseUrl + "/api/offboardingrequests/preview/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitializeOffboardingPreview(_response);
        });
    }

    protected processInitializeOffboardingPreview(response: Response): Promise<OffboardingPreviewDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OffboardingPreviewDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OffboardingPreviewDto>(null as any);
    }

    initializeOffboardingPreviewWithTemplate(employeeId: number, templateId: number | null): Promise<OffboardingPreviewDto> {
        let url_ = this.baseUrl + "/api/offboardingrequests/preview/{employeeId}/template/{templateId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        if (templateId === undefined || templateId === null)
            throw new Error("The parameter 'templateId' must be defined.");
        url_ = url_.replace("{templateId}", encodeURIComponent("" + templateId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitializeOffboardingPreviewWithTemplate(_response);
        });
    }

    protected processInitializeOffboardingPreviewWithTemplate(response: Response): Promise<OffboardingPreviewDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OffboardingPreviewDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OffboardingPreviewDto>(null as any);
    }

    createOffboardingFromPreview(command: CreateOffboardingFromPreviewCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOffboardingFromPreview(_response);
        });
    }

    protected processCreateOffboardingFromPreview(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createAndSubmitOffboarding(command: CreateOffboardingFromPreviewCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/generate-and-submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAndSubmitOffboarding(_response);
        });
    }

    protected processCreateAndSubmitOffboarding(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submitOffboardingRequest(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/{id}/submit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitOffboardingRequest(_response);
        });
    }

    protected processSubmitOffboardingRequest(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateOffboardingInfo(id: number, request: UpdateOffboardingInfoRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/{id}/info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateOffboardingInfo(_response);
        });
    }

    protected processUpdateOffboardingInfo(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendAllOffboardingTaskReminders(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/{id}/remind-all";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendAllOffboardingTaskReminders(_response);
        });
    }

    protected processSendAllOffboardingTaskReminders(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    markEmployeeAsExited(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/offboardingrequests/{id}/mark-exited";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkEmployeeAsExited(_response);
        });
    }

    protected processMarkEmployeeAsExited(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OnboardingRequestsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getOnboardingRequests(): Promise<OnboardingRequestDto[]> {
        let url_ = this.baseUrl + "/api/onboardingrequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOnboardingRequests(_response);
        });
    }

    protected processGetOnboardingRequests(response: Response): Promise<OnboardingRequestDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OnboardingRequestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnboardingRequestDto[]>(null as any);
    }

    createOnboardingRequest(command: CreateOnboardingRequestCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/onboardingrequests";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateOnboardingRequest(_response);
        });
    }

    protected processCreateOnboardingRequest(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    initializeOnboardingRequest(command: InitializeOnboardingRequestCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/onboardingrequests/initialize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInitializeOnboardingRequest(_response);
        });
    }

    protected processInitializeOnboardingRequest(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    applyTemplate(id: number, request: ApplyTemplateRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/apply-template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApplyTemplate(_response);
        });
    }

    protected processApplyTemplate(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submitOnboardingRequest(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/submit";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSubmitOnboardingRequest(_response);
        });
    }

    protected processSubmitOnboardingRequest(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    completeOnboardingRequest(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/complete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCompleteOnboardingRequest(_response);
        });
    }

    protected processCompleteOnboardingRequest(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addPostOnboardingTask(id: number, command: AddPostOnboardingTaskCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/add-task";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddPostOnboardingTask(_response);
        });
    }

    protected processAddPostOnboardingTask(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    discardOnboardingRequest(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDiscardOnboardingRequest(_response);
        });
    }

    protected processDiscardOnboardingRequest(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getOnboardingRequestPreview(id: number): Promise<OnboardingRequestPreviewDto> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/preview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetOnboardingRequestPreview(_response);
        });
    }

    protected processGetOnboardingRequestPreview(response: Response): Promise<OnboardingRequestPreviewDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OnboardingRequestPreviewDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OnboardingRequestPreviewDto>(null as any);
    }

    declineOnboardingRequest(id: number, request: DeclineOnboardingRequestRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/decline";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeclineOnboardingRequest(_response);
        });
    }

    protected processDeclineOnboardingRequest(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendAllOnboardingTaskReminders(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/onboardingrequests/{id}/remind-all";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendAllOnboardingTaskReminders(_response);
        });
    }

    protected processSendAllOnboardingTaskReminders(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PayrollCompaniesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getPayrollCompanies(): Promise<PayrollCompanyDto[]> {
        let url_ = this.baseUrl + "/api/payrollcompanies";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPayrollCompanies(_response);
        });
    }

    protected processGetPayrollCompanies(response: Response): Promise<PayrollCompanyDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PayrollCompanyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PayrollCompanyDto[]>(null as any);
    }

    createPayrollCompany(command: CreatePayrollCompanyCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/payrollcompanies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreatePayrollCompany(_response);
        });
    }

    protected processCreatePayrollCompany(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updatePayrollCompany(id: number, command: UpdatePayrollCompanyCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/payrollcompanies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePayrollCompany(_response);
        });
    }

    protected processUpdatePayrollCompany(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deletePayrollCompany(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/payrollcompanies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePayrollCompany(_response);
        });
    }

    protected processDeletePayrollCompany(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RequestItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTasksByPic(picId: string, status: RequestItemStatus | null | undefined, requestStatus: RequestStatus | null | undefined): Promise<PicTaskDto[]> {
        let url_ = this.baseUrl + "/api/requestitems/my-tasks/{picId}?";
        if (picId === undefined || picId === null)
            throw new Error("The parameter 'picId' must be defined.");
        url_ = url_.replace("{picId}", encodeURIComponent("" + picId));
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (requestStatus !== undefined && requestStatus !== null)
            url_ += "requestStatus=" + encodeURIComponent("" + requestStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTasksByPic(_response);
        });
    }

    protected processGetTasksByPic(response: Response): Promise<PicTaskDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PicTaskDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PicTaskDto[]>(null as any);
    }

    addCustomRequestItem(command: AddCustomRequestItemCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddCustomRequestItem(_response);
        });
    }

    protected processAddCustomRequestItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRequestItemPic(id: number, request: UpdateRequestItemPicRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/pic";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRequestItemPic(_response);
        });
    }

    protected processUpdateRequestItemPic(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    approveRequestItem(id: number, request: ApproveRequestItemRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApproveRequestItem(_response);
        });
    }

    protected processApproveRequestItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRequestItemStatus(id: number, request: UpdateRequestItemStatusRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRequestItemStatus(_response);
        });
    }

    protected processUpdateRequestItemStatus(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    assignAsset(id: number, request: AssignAssetRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/asset";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignAsset(_response);
        });
    }

    protected processAssignAsset(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reassignRequestItem(id: number, request: ReassignRequestItemRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/reassign";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processReassignRequestItem(_response);
        });
    }

    protected processReassignRequestItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addRequestItemRemark(id: number, request: AddRemarkRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/remark";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddRequestItemRemark(_response);
        });
    }

    protected processAddRequestItemRemark(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRequestItemLogs(id: number): Promise<RequestItemLogDto[]> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/logs";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRequestItemLogs(_response);
        });
    }

    protected processGetRequestItemLogs(response: Response): Promise<RequestItemLogDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RequestItemLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RequestItemLogDto[]>(null as any);
    }

    removeRequestItem(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveRequestItem(_response);
        });
    }

    protected processRemoveRequestItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendTaskReminder(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/requestitems/{id}/remind";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendTaskReminder(_response);
        });
    }

    protected processSendTaskReminder(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TeamsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTeams(): Promise<TeamDto[]> {
        let url_ = this.baseUrl + "/api/teams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeams(_response);
        });
    }

    protected processGetTeams(response: Response): Promise<TeamDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamDto[]>(null as any);
    }

    createTeam(command: CreateTeamCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/teams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTeam(_response);
        });
    }

    protected processCreateTeam(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getTeamMembers(teamId: number): Promise<TeamMemberDto[]> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTeamMembers(_response);
        });
    }

    protected processGetTeamMembers(response: Response): Promise<TeamMemberDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TeamMemberDto[]>(null as any);
    }

    addTeamMember(teamId: number, command: AddTeamMemberCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddTeamMember(_response);
        });
    }

    protected processAddTeamMember(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTeam(id: number, command: UpdateTeamCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTeam(_response);
        });
    }

    protected processUpdateTeam(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTeam(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/teams/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTeam(_response);
        });
    }

    protected processDeleteTeam(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeTeamMember(teamId: number, userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/teams/{teamId}/members/{userId}";
        if (teamId === undefined || teamId === null)
            throw new Error("The parameter 'teamId' must be defined.");
        url_ = url_.replace("{teamId}", encodeURIComponent("" + teamId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveTeamMember(_response);
        });
    }

    protected processRemoveTeamMember(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TemplateCategoriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTemplateCategories(isActive: boolean | null | undefined): Promise<TemplateCategoryListDto[]> {
        let url_ = this.baseUrl + "/api/templatecategories?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateCategories(_response);
        });
    }

    protected processGetTemplateCategories(response: Response): Promise<TemplateCategoryListDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateCategoryListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateCategoryListDto[]>(null as any);
    }

    createTemplateCategory(command: CreateTemplateCategoryCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/templatecategories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplateCategory(_response);
        });
    }

    protected processCreateTemplateCategory(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTemplateCategory(id: number, command: UpdateTemplateCategoryCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/templatecategories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplateCategory(_response);
        });
    }

    protected processUpdateTemplateCategory(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTemplateCategory(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/templatecategories/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplateCategory(_response);
        });
    }

    protected processDeleteTemplateCategory(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TemplatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTemplates(requestType: RequestType): Promise<TemplateDto[]> {
        let url_ = this.baseUrl + "/api/templates?";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined and cannot be null.");
        else
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplates(_response);
        });
    }

    protected processGetTemplates(response: Response): Promise<TemplateDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateDto[]>(null as any);
    }

    createTemplate(command: CreateTemplateCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplate(_response);
        });
    }

    protected processCreateTemplate(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getTemplatesList(): Promise<TemplateListDto[]> {
        let url_ = this.baseUrl + "/api/templates/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplatesList(_response);
        });
    }

    protected processGetTemplatesList(response: Response): Promise<TemplateListDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateListDto[]>(null as any);
    }

    updateTemplate(id: number, command: UpdateTemplateCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplate(_response);
        });
    }

    protected processUpdateTemplate(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTemplate(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplate(_response);
        });
    }

    protected processDeleteTemplate(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TemplateTasksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTemplateTasks(templateId: number | null | undefined, templateCategoryId: number | null | undefined, isActive: boolean | null | undefined): Promise<TemplateTaskListDto[]> {
        let url_ = this.baseUrl + "/api/templatetasks?";
        if (templateId !== undefined && templateId !== null)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (templateCategoryId !== undefined && templateCategoryId !== null)
            url_ += "TemplateCategoryId=" + encodeURIComponent("" + templateCategoryId) + "&";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTemplateTasks(_response);
        });
    }

    protected processGetTemplateTasks(response: Response): Promise<TemplateTaskListDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateTaskListDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateTaskListDto[]>(null as any);
    }

    createTemplateTask(command: CreateTemplateTaskCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/templatetasks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTemplateTask(_response);
        });
    }

    protected processCreateTemplateTask(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTemplateTask(id: number, command: UpdateTemplateTaskCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/templatetasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTemplateTask(_response);
        });
    }

    protected processUpdateTemplateTask(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTemplateTask(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/templatetasks/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTemplateTask(_response);
        });
    }

    protected processDeleteTemplateTask(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TodoItemsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTodoItemsWithPagination(listId: number, pageNumber: number, pageSize: number): Promise<PaginatedListOfTodoItemBriefDto> {
        let url_ = this.baseUrl + "/api/todoitems?";
        if (listId === undefined || listId === null)
            throw new Error("The parameter 'listId' must be defined and cannot be null.");
        else
            url_ += "ListId=" + encodeURIComponent("" + listId) + "&";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodoItemsWithPagination(_response);
        });
    }

    protected processGetTodoItemsWithPagination(response: Response): Promise<PaginatedListOfTodoItemBriefDto> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTodoItemBriefDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTodoItemBriefDto>(null as any);
    }

    createTodoItem(command: CreateTodoItemCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/todoitems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTodoItem(_response);
        });
    }

    protected processCreateTodoItem(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTodoItem(id: number, command: UpdateTodoItemCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/todoitems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodoItem(_response);
        });
    }

    protected processUpdateTodoItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTodoItem(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/todoitems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTodoItem(_response);
        });
    }

    protected processDeleteTodoItem(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateTodoItemDetail(id: number, command: UpdateTodoItemDetailCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/todoitems/UpdateDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodoItemDetail(_response);
        });
    }

    protected processUpdateTodoItemDetail(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TodoListsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTodoLists(): Promise<TodosVm> {
        let url_ = this.baseUrl + "/api/todolists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTodoLists(_response);
        });
    }

    protected processGetTodoLists(response: Response): Promise<TodosVm> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TodosVm.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TodosVm>(null as any);
    }

    createTodoList(command: CreateTodoListCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/todolists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateTodoList(_response);
        });
    }

    protected processCreateTodoList(response: Response): Promise<number> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    updateTodoList(id: number, command: UpdateTodoListCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/todolists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTodoList(_response);
        });
    }

    protected processUpdateTodoList(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteTodoList(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/todolists/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteTodoList(_response);
        });
    }

    protected processDeleteTodoList(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getApiUsersMe(): Promise<void> {
        let url_ = this.baseUrl + "/api/users/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUsersMe(_response);
        });
    }

    protected processGetApiUsersMe(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiUsersLogin(useCookies: boolean | null | undefined, useSessionCookies: boolean | null | undefined, login: LoginRequest): Promise<RedirectResponse> {
        let url_ = this.baseUrl + "/api/users/login?";
        if (useCookies !== undefined && useCookies !== null)
            url_ += "useCookies=" + encodeURIComponent("" + useCookies) + "&";
        if (useSessionCookies !== undefined && useSessionCookies !== null)
            url_ += "useSessionCookies=" + encodeURIComponent("" + useSessionCookies) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiUsersLogin(_response);
        });
    }

    protected processPostApiUsersLogin(response: Response): Promise<RedirectResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedirectResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RedirectResponse>(null as any);
    }

    postApiUsersLogout(): Promise<void> {
        let url_ = this.baseUrl + "/api/users/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiUsersLogout(_response);
        });
    }

    protected processPostApiUsersLogout(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getApiUsers(): Promise<void> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApiUsers(_response);
        });
    }

    protected processGetApiUsers(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiUsersRefresh(refreshRequest: RefreshRequest): Promise<AccessTokenResponse> {
        let url_ = this.baseUrl + "/api/users/refresh";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(refreshRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiUsersRefresh(_response);
        });
    }

    protected processPostApiUsersRefresh(response: Response): Promise<AccessTokenResponse> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessTokenResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessTokenResponse>(null as any);
    }

    postApiUsersForgotPassword(resetRequest: ForgotPasswordRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/users/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiUsersForgotPassword(_response);
        });
    }

    protected processPostApiUsersForgotPassword(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postApiUsersRegister(registration: RegisterRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/users/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registration);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPostApiUsersRegister(_response);
        });
    }

    protected processPostApiUsersRegister(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = HttpValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUsers(): Promise<ApplicationUserDto[]> {
        let url_ = this.baseUrl + "/api/users/admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<ApplicationUserDto[]> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto[]>(null as any);
    }

    createSystemUser(command: CreateSystemUserCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/users/admin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSystemUser(_response);
        });
    }

    protected processCreateSystemUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateSystemUser(userId: string, request: UpdateSystemUserRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/users/admin/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSystemUser(_response);
        });
    }

    protected processUpdateSystemUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    activateUser(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/admin/{userId}/activate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivateUser(_response);
        });
    }

    protected processActivateUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivateUser(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/admin/{userId}/deactivate";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateUser(_response);
        });
    }

    protected processDeactivateUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    archiveUser(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/admin/{userId}/archive";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processArchiveUser(_response);
        });
    }

    protected processArchiveUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unarchiveUser(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/users/admin/{userId}/unarchive";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnarchiveUser(_response);
        });
    }

    protected processUnarchiveUser(response: Response): Promise<void> {
        followIfLoginRedirect(response);
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApprovalDecisionRequest implements IApprovalDecisionRequest {
    token?: string;
    action?: string;
    rejectionReason?: string | undefined;

    constructor(data?: IApprovalDecisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.action = _data["action"];
            this.rejectionReason = _data["rejectionReason"];
        }
    }

    static fromJS(data: any): ApprovalDecisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalDecisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["action"] = this.action;
        data["rejectionReason"] = this.rejectionReason;
        return data;
    }
}

export interface IApprovalDecisionRequest {
    token?: string;
    action?: string;
    rejectionReason?: string | undefined;
}

export class RequestNewLinkRequest implements IRequestNewLinkRequest {
    approvalId?: number;
    approverEmail?: string;

    constructor(data?: IRequestNewLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvalId = _data["approvalId"];
            this.approverEmail = _data["approverEmail"];
        }
    }

    static fromJS(data: any): RequestNewLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RequestNewLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvalId"] = this.approvalId;
        data["approverEmail"] = this.approverEmail;
        return data;
    }
}

export interface IRequestNewLinkRequest {
    approvalId?: number;
    approverEmail?: string;
}

export class DashboardDataDto implements IDashboardDataDto {
    totalEmployees?: number;
    departmentEmployees?: number;
    activeOnboardingRequests?: number;
    activeOffboardingRequests?: number;
    pendingApprovals?: number;
    pendingTasks?: number;
    recentActivities?: ActivityDto[];
    requestsByCategory?: { [key: string]: number; };

    constructor(data?: IDashboardDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalEmployees = _data["totalEmployees"];
            this.departmentEmployees = _data["departmentEmployees"];
            this.activeOnboardingRequests = _data["activeOnboardingRequests"];
            this.activeOffboardingRequests = _data["activeOffboardingRequests"];
            this.pendingApprovals = _data["pendingApprovals"];
            this.pendingTasks = _data["pendingTasks"];
            if (Array.isArray(_data["recentActivities"])) {
                this.recentActivities = [] as any;
                for (let item of _data["recentActivities"])
                    this.recentActivities!.push(ActivityDto.fromJS(item));
            }
            if (_data["requestsByCategory"]) {
                this.requestsByCategory = {} as any;
                for (let key in _data["requestsByCategory"]) {
                    if (_data["requestsByCategory"].hasOwnProperty(key))
                        (<any>this.requestsByCategory)![key] = _data["requestsByCategory"][key];
                }
            }
        }
    }

    static fromJS(data: any): DashboardDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalEmployees"] = this.totalEmployees;
        data["departmentEmployees"] = this.departmentEmployees;
        data["activeOnboardingRequests"] = this.activeOnboardingRequests;
        data["activeOffboardingRequests"] = this.activeOffboardingRequests;
        data["pendingApprovals"] = this.pendingApprovals;
        data["pendingTasks"] = this.pendingTasks;
        if (Array.isArray(this.recentActivities)) {
            data["recentActivities"] = [];
            for (let item of this.recentActivities)
                data["recentActivities"].push(item.toJSON());
        }
        if (this.requestsByCategory) {
            data["requestsByCategory"] = {};
            for (let key in this.requestsByCategory) {
                if (this.requestsByCategory.hasOwnProperty(key))
                    (<any>data["requestsByCategory"])[key] = (<any>this.requestsByCategory)[key];
            }
        }
        return data;
    }
}

export interface IDashboardDataDto {
    totalEmployees?: number;
    departmentEmployees?: number;
    activeOnboardingRequests?: number;
    activeOffboardingRequests?: number;
    pendingApprovals?: number;
    pendingTasks?: number;
    recentActivities?: ActivityDto[];
    requestsByCategory?: { [key: string]: number; };
}

export class ActivityDto implements IActivityDto {
    id?: number;
    action?: string;
    itemType?: string;
    employeeName?: string;
    userEmail?: string;
    timestamp?: Date;
    remarks?: string | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.itemType = _data["itemType"];
            this.employeeName = _data["employeeName"];
            this.userEmail = _data["userEmail"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["itemType"] = this.itemType;
        data["employeeName"] = this.employeeName;
        data["userEmail"] = this.userEmail;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IActivityDto {
    id?: number;
    action?: string;
    itemType?: string;
    employeeName?: string;
    userEmail?: string;
    timestamp?: Date;
    remarks?: string | undefined;
}

export class MyTasksDashboardDto implements IMyTasksDashboardDto {
    waitingForMeCount?: number;
    waitingForOthersCount?: number;
    completedCount?: number;
    draftsCount?: number;
    onboardingDraftsCount?: number;
    offboardingDraftsCount?: number;
    waitingForMe?: EmployeeTaskGroupDto[];
    waitingForOthers?: EmployeeTaskGroupDto[];
    completed?: EmployeeTaskGroupDto[];

    constructor(data?: IMyTasksDashboardDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.waitingForMeCount = _data["waitingForMeCount"];
            this.waitingForOthersCount = _data["waitingForOthersCount"];
            this.completedCount = _data["completedCount"];
            this.draftsCount = _data["draftsCount"];
            this.onboardingDraftsCount = _data["onboardingDraftsCount"];
            this.offboardingDraftsCount = _data["offboardingDraftsCount"];
            if (Array.isArray(_data["waitingForMe"])) {
                this.waitingForMe = [] as any;
                for (let item of _data["waitingForMe"])
                    this.waitingForMe!.push(EmployeeTaskGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["waitingForOthers"])) {
                this.waitingForOthers = [] as any;
                for (let item of _data["waitingForOthers"])
                    this.waitingForOthers!.push(EmployeeTaskGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["completed"])) {
                this.completed = [] as any;
                for (let item of _data["completed"])
                    this.completed!.push(EmployeeTaskGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MyTasksDashboardDto {
        data = typeof data === 'object' ? data : {};
        let result = new MyTasksDashboardDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["waitingForMeCount"] = this.waitingForMeCount;
        data["waitingForOthersCount"] = this.waitingForOthersCount;
        data["completedCount"] = this.completedCount;
        data["draftsCount"] = this.draftsCount;
        data["onboardingDraftsCount"] = this.onboardingDraftsCount;
        data["offboardingDraftsCount"] = this.offboardingDraftsCount;
        if (Array.isArray(this.waitingForMe)) {
            data["waitingForMe"] = [];
            for (let item of this.waitingForMe)
                data["waitingForMe"].push(item.toJSON());
        }
        if (Array.isArray(this.waitingForOthers)) {
            data["waitingForOthers"] = [];
            for (let item of this.waitingForOthers)
                data["waitingForOthers"].push(item.toJSON());
        }
        if (Array.isArray(this.completed)) {
            data["completed"] = [];
            for (let item of this.completed)
                data["completed"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMyTasksDashboardDto {
    waitingForMeCount?: number;
    waitingForOthersCount?: number;
    completedCount?: number;
    draftsCount?: number;
    onboardingDraftsCount?: number;
    offboardingDraftsCount?: number;
    waitingForMe?: EmployeeTaskGroupDto[];
    waitingForOthers?: EmployeeTaskGroupDto[];
    completed?: EmployeeTaskGroupDto[];
}

export class EmployeeTaskGroupDto implements IEmployeeTaskGroupDto {
    employeeId?: number | undefined;
    employeeName?: string;
    employeeNumber?: string | undefined;
    department?: string | undefined;
    location?: string | undefined;
    requestId?: number;
    requestType?: string;
    requestStatus?: string;
    tasks?: TaskItemDto[];
    taskCount?: number;

    constructor(data?: IEmployeeTaskGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeNumber = _data["employeeNumber"];
            this.department = _data["department"];
            this.location = _data["location"];
            this.requestId = _data["requestId"];
            this.requestType = _data["requestType"];
            this.requestStatus = _data["requestStatus"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TaskItemDto.fromJS(item));
            }
            this.taskCount = _data["taskCount"];
        }
    }

    static fromJS(data: any): EmployeeTaskGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTaskGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeNumber"] = this.employeeNumber;
        data["department"] = this.department;
        data["location"] = this.location;
        data["requestId"] = this.requestId;
        data["requestType"] = this.requestType;
        data["requestStatus"] = this.requestStatus;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        data["taskCount"] = this.taskCount;
        return data;
    }
}

export interface IEmployeeTaskGroupDto {
    employeeId?: number | undefined;
    employeeName?: string;
    employeeNumber?: string | undefined;
    department?: string | undefined;
    location?: string | undefined;
    requestId?: number;
    requestType?: string;
    requestStatus?: string;
    tasks?: TaskItemDto[];
    taskCount?: number;
}

export class TaskItemDto implements ITaskItemDto {
    id?: number;
    itemName?: string;
    description?: string | undefined;
    status?: string;
    statusValue?: number;
    category?: string | undefined;
    teamName?: string | undefined;
    dueDate?: Date | undefined;
    requiresApproval?: boolean;
    approvalStatus?: string | undefined;
    approverEmail?: string | undefined;
    assignedAsset?: string | undefined;
    completedDate?: Date | undefined;

    constructor(data?: ITaskItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.statusValue = _data["statusValue"];
            this.category = _data["category"];
            this.teamName = _data["teamName"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.requiresApproval = _data["requiresApproval"];
            this.approvalStatus = _data["approvalStatus"];
            this.approverEmail = _data["approverEmail"];
            this.assignedAsset = _data["assignedAsset"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaskItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["statusValue"] = this.statusValue;
        data["category"] = this.category;
        data["teamName"] = this.teamName;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["requiresApproval"] = this.requiresApproval;
        data["approvalStatus"] = this.approvalStatus;
        data["approverEmail"] = this.approverEmail;
        data["assignedAsset"] = this.assignedAsset;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITaskItemDto {
    id?: number;
    itemName?: string;
    description?: string | undefined;
    status?: string;
    statusValue?: number;
    category?: string | undefined;
    teamName?: string | undefined;
    dueDate?: Date | undefined;
    requiresApproval?: boolean;
    approvalStatus?: string | undefined;
    approverEmail?: string | undefined;
    assignedAsset?: string | undefined;
    completedDate?: Date | undefined;
}

export class DepartmentDto implements IDepartmentDto {
    id?: number;
    name?: string;
    locationId?: number;
    locationName?: string;
    employeeCount?: number;

    constructor(data?: IDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.employeeCount = _data["employeeCount"];
        }
    }

    static fromJS(data: any): DepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["employeeCount"] = this.employeeCount;
        return data;
    }
}

export interface IDepartmentDto {
    id?: number;
    name?: string;
    locationId?: number;
    locationName?: string;
    employeeCount?: number;
}

export class CreateDepartmentCommand implements ICreateDepartmentCommand {
    name?: string;
    locationId?: number;

    constructor(data?: ICreateDepartmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): CreateDepartmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDepartmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface ICreateDepartmentCommand {
    name?: string;
    locationId?: number;
}

export class UpdateDepartmentCommand implements IUpdateDepartmentCommand {
    id?: number;
    name?: string;
    locationId?: number;

    constructor(data?: IUpdateDepartmentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.locationId = _data["locationId"];
        }
    }

    static fromJS(data: any): UpdateDepartmentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDepartmentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["locationId"] = this.locationId;
        return data;
    }
}

export interface IUpdateDepartmentCommand {
    id?: number;
    name?: string;
    locationId?: number;
}

export class EmployeeDto implements IEmployeeDto {
    id?: number;
    fullName?: string | undefined;
    employeeNumber?: string | undefined;
    location?: string | undefined;
    department?: string | undefined;
    designation?: string | undefined;
    personalEmail?: string | undefined;
    workEmail?: string | undefined;
    immediateSuperior?: string | undefined;
    reportingSuperior?: string | undefined;
    employmentDate?: Date;
    lastWorkingDate?: Date | undefined;
    isActive?: boolean;
    created?: Date;
    lastModified?: Date;
    offboardingReason?: OffboardingReason | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.employeeNumber = _data["employeeNumber"];
            this.location = _data["location"];
            this.department = _data["department"];
            this.designation = _data["designation"];
            this.personalEmail = _data["personalEmail"];
            this.workEmail = _data["workEmail"];
            this.immediateSuperior = _data["immediateSuperior"];
            this.reportingSuperior = _data["reportingSuperior"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.offboardingReason = _data["offboardingReason"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["employeeNumber"] = this.employeeNumber;
        data["location"] = this.location;
        data["department"] = this.department;
        data["designation"] = this.designation;
        data["personalEmail"] = this.personalEmail;
        data["workEmail"] = this.workEmail;
        data["immediateSuperior"] = this.immediateSuperior;
        data["reportingSuperior"] = this.reportingSuperior;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["offboardingReason"] = this.offboardingReason;
        return data;
    }
}

export interface IEmployeeDto {
    id?: number;
    fullName?: string | undefined;
    employeeNumber?: string | undefined;
    location?: string | undefined;
    department?: string | undefined;
    designation?: string | undefined;
    personalEmail?: string | undefined;
    workEmail?: string | undefined;
    immediateSuperior?: string | undefined;
    reportingSuperior?: string | undefined;
    employmentDate?: Date;
    lastWorkingDate?: Date | undefined;
    isActive?: boolean;
    created?: Date;
    lastModified?: Date;
    offboardingReason?: OffboardingReason | undefined;
}

export enum OffboardingReason {
    Resigned = 1,
    Retrenched = 2,
    Dismissed = 3,
    Retired = 4,
    ExpiryOfContract = 5,
    Deceased = 6,
    Other = 99,
}

export class CreateEmployeeCommand implements ICreateEmployeeCommand {
    fullName?: string;
    employeeNumber?: string;
    locationId?: number;
    departmentId?: number;
    designation?: string | undefined;
    personalEmail?: string;
    workEmail?: string | undefined;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;

    constructor(data?: ICreateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.employeeNumber = _data["employeeNumber"];
            this.locationId = _data["locationId"];
            this.departmentId = _data["departmentId"];
            this.designation = _data["designation"];
            this.personalEmail = _data["personalEmail"];
            this.workEmail = _data["workEmail"];
            this.immediateSuperiorEmail = _data["immediateSuperiorEmail"];
            this.reportingSuperiorEmail = _data["reportingSuperiorEmail"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["employeeNumber"] = this.employeeNumber;
        data["locationId"] = this.locationId;
        data["departmentId"] = this.departmentId;
        data["designation"] = this.designation;
        data["personalEmail"] = this.personalEmail;
        data["workEmail"] = this.workEmail;
        data["immediateSuperiorEmail"] = this.immediateSuperiorEmail;
        data["reportingSuperiorEmail"] = this.reportingSuperiorEmail;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICreateEmployeeCommand {
    fullName?: string;
    employeeNumber?: string;
    locationId?: number;
    departmentId?: number;
    designation?: string | undefined;
    personalEmail?: string;
    workEmail?: string | undefined;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;
}

export class UpdateEmployeeCommand implements IUpdateEmployeeCommand {
    id?: number;
    fullName?: string;
    locationId?: number;
    departmentId?: number;
    designation?: string | undefined;
    personalEmail?: string;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;

    constructor(data?: IUpdateEmployeeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.locationId = _data["locationId"];
            this.departmentId = _data["departmentId"];
            this.designation = _data["designation"];
            this.personalEmail = _data["personalEmail"];
            this.immediateSuperiorEmail = _data["immediateSuperiorEmail"];
            this.reportingSuperiorEmail = _data["reportingSuperiorEmail"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateEmployeeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEmployeeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["locationId"] = this.locationId;
        data["departmentId"] = this.departmentId;
        data["designation"] = this.designation;
        data["personalEmail"] = this.personalEmail;
        data["immediateSuperiorEmail"] = this.immediateSuperiorEmail;
        data["reportingSuperiorEmail"] = this.reportingSuperiorEmail;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateEmployeeCommand {
    id?: number;
    fullName?: string;
    locationId?: number;
    departmentId?: number;
    designation?: string | undefined;
    personalEmail?: string;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;
}

export class LocationDto implements ILocationDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    departmentCount?: number;
    employeeCount?: number;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.departmentCount = _data["departmentCount"];
            this.employeeCount = _data["employeeCount"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["departmentCount"] = this.departmentCount;
        data["employeeCount"] = this.employeeCount;
        return data;
    }
}

export interface ILocationDto {
    id?: number;
    name?: string;
    code?: string | undefined;
    departmentCount?: number;
    employeeCount?: number;
}

export class CreateLocationCommand implements ICreateLocationCommand {
    name?: string;
    code?: string | undefined;

    constructor(data?: ICreateLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): CreateLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface ICreateLocationCommand {
    name?: string;
    code?: string | undefined;
}

export class UpdateLocationCommand implements IUpdateLocationCommand {
    id?: number;
    name?: string;
    code?: string | undefined;

    constructor(data?: IUpdateLocationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): UpdateLocationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        return data;
    }
}

export interface IUpdateLocationCommand {
    id?: number;
    name?: string;
    code?: string | undefined;
}

export class OffboardingRequestDto implements IOffboardingRequestDto {
    id?: number;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    employeeNo?: string | undefined;
    locationName?: string | undefined;
    departmentName?: string | undefined;
    designation?: string | undefined;
    employmentDate?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    offboardingReason?: OffboardingReason | undefined;
    status?: RequestStatus;
    submittedBy?: string | undefined;
    submittedDate?: Date | undefined;
    completedDate?: Date | undefined;
    totalTasks?: number;
    completedTasks?: number;
    revokeCount?: number;
    returnCount?: number;
    extendedCount?: number;

    constructor(data?: IOffboardingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeNo = _data["employeeNo"];
            this.locationName = _data["locationName"];
            this.departmentName = _data["departmentName"];
            this.designation = _data["designation"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.offboardingReason = _data["offboardingReason"];
            this.status = _data["status"];
            this.submittedBy = _data["submittedBy"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
            this.revokeCount = _data["revokeCount"];
            this.returnCount = _data["returnCount"];
            this.extendedCount = _data["extendedCount"];
        }
    }

    static fromJS(data: any): OffboardingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffboardingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeNo"] = this.employeeNo;
        data["locationName"] = this.locationName;
        data["departmentName"] = this.departmentName;
        data["designation"] = this.designation;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["offboardingReason"] = this.offboardingReason;
        data["status"] = this.status;
        data["submittedBy"] = this.submittedBy;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        data["revokeCount"] = this.revokeCount;
        data["returnCount"] = this.returnCount;
        data["extendedCount"] = this.extendedCount;
        return data;
    }
}

export interface IOffboardingRequestDto {
    id?: number;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    employeeNo?: string | undefined;
    locationName?: string | undefined;
    departmentName?: string | undefined;
    designation?: string | undefined;
    employmentDate?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    offboardingReason?: OffboardingReason | undefined;
    status?: RequestStatus;
    submittedBy?: string | undefined;
    submittedDate?: Date | undefined;
    completedDate?: Date | undefined;
    totalTasks?: number;
    completedTasks?: number;
    revokeCount?: number;
    returnCount?: number;
    extendedCount?: number;
}

export enum RequestStatus {
    Draft = 0,
    Pending = 1,
    PendingFirstApproval = 2,
    PendingSecondApproval = 3,
    Approved = 4,
    InProgress = 5,
    Completed = 6,
    Rejected = 7,
    Cancelled = 8,
}

export class OffboardingRequestDetailsDto implements IOffboardingRequestDetailsDto {
    boardingRequestId?: number;
    status?: RequestStatus;
    offboardingReason?: OffboardingReason | undefined;
    lastWorkingDate?: Date | undefined;
    remarks?: string | undefined;
    submittedBy?: string | undefined;
    submittedDate?: Date | undefined;
    completedDate?: Date | undefined;
    completedBy?: string | undefined;
    employee?: EmployeePreviewDto;
    categories?: OffboardingCategoryDto[];
    totalTasks?: number;
    completedTasks?: number;
    revokeCount?: number;
    returnCount?: number;
    extendedCount?: number;

    constructor(data?: IOffboardingRequestDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardingRequestId = _data["boardingRequestId"];
            this.status = _data["status"];
            this.offboardingReason = _data["offboardingReason"];
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.submittedBy = _data["submittedBy"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.completedBy = _data["completedBy"];
            this.employee = _data["employee"] ? EmployeePreviewDto.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(OffboardingCategoryDto.fromJS(item));
            }
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
            this.revokeCount = _data["revokeCount"];
            this.returnCount = _data["returnCount"];
            this.extendedCount = _data["extendedCount"];
        }
    }

    static fromJS(data: any): OffboardingRequestDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffboardingRequestDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardingRequestId"] = this.boardingRequestId;
        data["status"] = this.status;
        data["offboardingReason"] = this.offboardingReason;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["submittedBy"] = this.submittedBy;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["completedBy"] = this.completedBy;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        data["revokeCount"] = this.revokeCount;
        data["returnCount"] = this.returnCount;
        data["extendedCount"] = this.extendedCount;
        return data;
    }
}

export interface IOffboardingRequestDetailsDto {
    boardingRequestId?: number;
    status?: RequestStatus;
    offboardingReason?: OffboardingReason | undefined;
    lastWorkingDate?: Date | undefined;
    remarks?: string | undefined;
    submittedBy?: string | undefined;
    submittedDate?: Date | undefined;
    completedDate?: Date | undefined;
    completedBy?: string | undefined;
    employee?: EmployeePreviewDto;
    categories?: OffboardingCategoryDto[];
    totalTasks?: number;
    completedTasks?: number;
    revokeCount?: number;
    returnCount?: number;
    extendedCount?: number;
}

export class EmployeePreviewDto implements IEmployeePreviewDto {
    id?: number;
    fullName?: string;
    employeeNumber?: string;
    personalEmail?: string;
    designation?: string;
    locationId?: number;
    locationName?: string;
    departmentId?: number;
    departmentName?: string;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;

    constructor(data?: IEmployeePreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.employeeNumber = _data["employeeNumber"];
            this.personalEmail = _data["personalEmail"];
            this.designation = _data["designation"];
            this.locationId = _data["locationId"];
            this.locationName = _data["locationName"];
            this.departmentId = _data["departmentId"];
            this.departmentName = _data["departmentName"];
            this.immediateSuperiorEmail = _data["immediateSuperiorEmail"];
            this.reportingSuperiorEmail = _data["reportingSuperiorEmail"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeePreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeePreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["employeeNumber"] = this.employeeNumber;
        data["personalEmail"] = this.personalEmail;
        data["designation"] = this.designation;
        data["locationId"] = this.locationId;
        data["locationName"] = this.locationName;
        data["departmentId"] = this.departmentId;
        data["departmentName"] = this.departmentName;
        data["immediateSuperiorEmail"] = this.immediateSuperiorEmail;
        data["reportingSuperiorEmail"] = this.reportingSuperiorEmail;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployeePreviewDto {
    id?: number;
    fullName?: string;
    employeeNumber?: string;
    personalEmail?: string;
    designation?: string;
    locationId?: number;
    locationName?: string;
    departmentId?: number;
    departmentName?: string;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;
}

export class OffboardingCategoryDto implements IOffboardingCategoryDto {
    categoryId?: number;
    categoryName?: string;
    displayOrder?: number;
    items?: OffboardingItemPreviewDto[];

    constructor(data?: IOffboardingCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OffboardingItemPreviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OffboardingCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffboardingCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOffboardingCategoryDto {
    categoryId?: number;
    categoryName?: string;
    displayOrder?: number;
    items?: OffboardingItemPreviewDto[];
}

export class OffboardingItemPreviewDto implements IOffboardingItemPreviewDto {
    id?: number;
    itemName?: string;
    description?: string | undefined;
    status?: RequestItemStatus;
    displayOrder?: number;
    picId?: string | undefined;
    teamId?: number | undefined;
    assignedPersonName?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedAsset?: string | undefined;
    dueDate?: Date | undefined;
    offboardingAction?: OffboardingAction | undefined;
    extendedUntil?: Date | undefined;
    latestRemark?: string | undefined;
    latestRemarkDate?: Date | undefined;

    constructor(data?: IOffboardingItemPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.displayOrder = _data["displayOrder"];
            this.picId = _data["picId"];
            this.teamId = _data["teamId"];
            this.assignedPersonName = _data["assignedPersonName"];
            this.assignedTeamName = _data["assignedTeamName"];
            this.assignedAsset = _data["assignedAsset"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.offboardingAction = _data["offboardingAction"];
            this.extendedUntil = _data["extendedUntil"] ? new Date(_data["extendedUntil"].toString()) : <any>undefined;
            this.latestRemark = _data["latestRemark"];
            this.latestRemarkDate = _data["latestRemarkDate"] ? new Date(_data["latestRemarkDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OffboardingItemPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffboardingItemPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["displayOrder"] = this.displayOrder;
        data["picId"] = this.picId;
        data["teamId"] = this.teamId;
        data["assignedPersonName"] = this.assignedPersonName;
        data["assignedTeamName"] = this.assignedTeamName;
        data["assignedAsset"] = this.assignedAsset;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["offboardingAction"] = this.offboardingAction;
        data["extendedUntil"] = this.extendedUntil ? this.extendedUntil.toISOString() : <any>undefined;
        data["latestRemark"] = this.latestRemark;
        data["latestRemarkDate"] = this.latestRemarkDate ? this.latestRemarkDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOffboardingItemPreviewDto {
    id?: number;
    itemName?: string;
    description?: string | undefined;
    status?: RequestItemStatus;
    displayOrder?: number;
    picId?: string | undefined;
    teamId?: number | undefined;
    assignedPersonName?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedAsset?: string | undefined;
    dueDate?: Date | undefined;
    offboardingAction?: OffboardingAction | undefined;
    extendedUntil?: Date | undefined;
    latestRemark?: string | undefined;
    latestRemarkDate?: Date | undefined;
}

export enum RequestItemStatus {
    Pending = 0,
    Completed = 1,
    Rejected = 2,
    Returned = 3,
}

export enum OffboardingAction {
    Outstanding = 0,
    Revoked = 1,
    Returned = 2,
    Extended = 3,
}

export class OffboardingPreviewDto implements IOffboardingPreviewDto {
    employeeId?: number;
    employeeName?: string;
    locationName?: string | undefined;
    departmentName?: string | undefined;
    designation?: string | undefined;
    employmentDate?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    suggestedTasks?: PreviewTaskDto[];

    constructor(data?: IOffboardingPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.locationName = _data["locationName"];
            this.departmentName = _data["departmentName"];
            this.designation = _data["designation"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["suggestedTasks"])) {
                this.suggestedTasks = [] as any;
                for (let item of _data["suggestedTasks"])
                    this.suggestedTasks!.push(PreviewTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OffboardingPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OffboardingPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["locationName"] = this.locationName;
        data["departmentName"] = this.departmentName;
        data["designation"] = this.designation;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.suggestedTasks)) {
            data["suggestedTasks"] = [];
            for (let item of this.suggestedTasks)
                data["suggestedTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOffboardingPreviewDto {
    employeeId?: number;
    employeeName?: string;
    locationName?: string | undefined;
    departmentName?: string | undefined;
    designation?: string | undefined;
    employmentDate?: Date | undefined;
    lastWorkingDate?: Date | undefined;
    suggestedTasks?: PreviewTaskDto[];
}

export class PreviewTaskDto implements IPreviewTaskDto {
    itemName?: string;
    description?: string | undefined;
    assignedAsset?: string | undefined;
    picId?: string | undefined;
    picName?: string | undefined;
    teamId?: number | undefined;
    teamName?: string | undefined;
    templateCategoryId?: number | undefined;
    categoryName?: string | undefined;
    defaultAction?: OffboardingAction;
    sourcePhase?: TaskPhase;
    sourceTaskId?: number;
    source?: TaskSource;
    isSelected?: boolean;
    displayOrder?: number;
    sourceStatus?: RequestItemStatus;
    completedDate?: Date | undefined;
    remarks?: string | undefined;
    isAlreadyReturned?: boolean;

    constructor(data?: IPreviewTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.assignedAsset = _data["assignedAsset"];
            this.picId = _data["picId"];
            this.picName = _data["picName"];
            this.teamId = _data["teamId"];
            this.teamName = _data["teamName"];
            this.templateCategoryId = _data["templateCategoryId"];
            this.categoryName = _data["categoryName"];
            this.defaultAction = _data["defaultAction"];
            this.sourcePhase = _data["sourcePhase"];
            this.sourceTaskId = _data["sourceTaskId"];
            this.source = _data["source"];
            this.isSelected = _data["isSelected"];
            this.displayOrder = _data["displayOrder"];
            this.sourceStatus = _data["sourceStatus"];
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.isAlreadyReturned = _data["isAlreadyReturned"];
        }
    }

    static fromJS(data: any): PreviewTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreviewTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["assignedAsset"] = this.assignedAsset;
        data["picId"] = this.picId;
        data["picName"] = this.picName;
        data["teamId"] = this.teamId;
        data["teamName"] = this.teamName;
        data["templateCategoryId"] = this.templateCategoryId;
        data["categoryName"] = this.categoryName;
        data["defaultAction"] = this.defaultAction;
        data["sourcePhase"] = this.sourcePhase;
        data["sourceTaskId"] = this.sourceTaskId;
        data["source"] = this.source;
        data["isSelected"] = this.isSelected;
        data["displayOrder"] = this.displayOrder;
        data["sourceStatus"] = this.sourceStatus;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["isAlreadyReturned"] = this.isAlreadyReturned;
        return data;
    }
}

export interface IPreviewTaskDto {
    itemName?: string;
    description?: string | undefined;
    assignedAsset?: string | undefined;
    picId?: string | undefined;
    picName?: string | undefined;
    teamId?: number | undefined;
    teamName?: string | undefined;
    templateCategoryId?: number | undefined;
    categoryName?: string | undefined;
    defaultAction?: OffboardingAction;
    sourcePhase?: TaskPhase;
    sourceTaskId?: number;
    source?: TaskSource;
    isSelected?: boolean;
    displayOrder?: number;
    sourceStatus?: RequestItemStatus;
    completedDate?: Date | undefined;
    remarks?: string | undefined;
    isAlreadyReturned?: boolean;
}

export enum TaskPhase {
    Onboarding = 1,
    PostOnboarding = 2,
}

export enum TaskSource {
    Template = 1,
    Onboarding = 2,
    Both = 3,
    Manual = 4,
}

export class CreateOffboardingFromPreviewCommand implements ICreateOffboardingFromPreviewCommand {
    employeeId?: number;
    lastWorkingDate?: Date | undefined;
    reason?: OffboardingReason | undefined;
    remarks?: string | undefined;
    templateId?: number | undefined;
    selectedTasks?: OffboardingTaskInput[];

    constructor(data?: ICreateOffboardingFromPreviewCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remarks = _data["remarks"];
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["selectedTasks"])) {
                this.selectedTasks = [] as any;
                for (let item of _data["selectedTasks"])
                    this.selectedTasks!.push(OffboardingTaskInput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOffboardingFromPreviewCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOffboardingFromPreviewCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["remarks"] = this.remarks;
        data["templateId"] = this.templateId;
        if (Array.isArray(this.selectedTasks)) {
            data["selectedTasks"] = [];
            for (let item of this.selectedTasks)
                data["selectedTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOffboardingFromPreviewCommand {
    employeeId?: number;
    lastWorkingDate?: Date | undefined;
    reason?: OffboardingReason | undefined;
    remarks?: string | undefined;
    templateId?: number | undefined;
    selectedTasks?: OffboardingTaskInput[];
}

export class OffboardingTaskInput implements IOffboardingTaskInput {
    itemName?: string;
    description?: string | undefined;
    assignedAsset?: string | undefined;
    picId?: string | undefined;
    teamId?: number | undefined;
    templateCategoryId?: number | undefined;
    offboardingAction?: OffboardingAction;
    extendedUntil?: Date | undefined;
    remarks?: string | undefined;
    sourceTaskId?: number | undefined;
    displayOrder?: number;

    constructor(data?: IOffboardingTaskInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.assignedAsset = _data["assignedAsset"];
            this.picId = _data["picId"];
            this.teamId = _data["teamId"];
            this.templateCategoryId = _data["templateCategoryId"];
            this.offboardingAction = _data["offboardingAction"];
            this.extendedUntil = _data["extendedUntil"] ? new Date(_data["extendedUntil"].toString()) : <any>undefined;
            this.remarks = _data["remarks"];
            this.sourceTaskId = _data["sourceTaskId"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): OffboardingTaskInput {
        data = typeof data === 'object' ? data : {};
        let result = new OffboardingTaskInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["assignedAsset"] = this.assignedAsset;
        data["picId"] = this.picId;
        data["teamId"] = this.teamId;
        data["templateCategoryId"] = this.templateCategoryId;
        data["offboardingAction"] = this.offboardingAction;
        data["extendedUntil"] = this.extendedUntil ? this.extendedUntil.toISOString() : <any>undefined;
        data["remarks"] = this.remarks;
        data["sourceTaskId"] = this.sourceTaskId;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface IOffboardingTaskInput {
    itemName?: string;
    description?: string | undefined;
    assignedAsset?: string | undefined;
    picId?: string | undefined;
    teamId?: number | undefined;
    templateCategoryId?: number | undefined;
    offboardingAction?: OffboardingAction;
    extendedUntil?: Date | undefined;
    remarks?: string | undefined;
    sourceTaskId?: number | undefined;
    displayOrder?: number;
}

export class UpdateOffboardingInfoRequest implements IUpdateOffboardingInfoRequest {
    lastWorkingDate?: Date | undefined;
    reason?: OffboardingReason | undefined;
    remarks?: string | undefined;

    constructor(data?: IUpdateOffboardingInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastWorkingDate = _data["lastWorkingDate"] ? new Date(_data["lastWorkingDate"].toString()) : <any>undefined;
            this.reason = _data["reason"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): UpdateOffboardingInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOffboardingInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastWorkingDate"] = this.lastWorkingDate ? this.lastWorkingDate.toISOString() : <any>undefined;
        data["reason"] = this.reason;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IUpdateOffboardingInfoRequest {
    lastWorkingDate?: Date | undefined;
    reason?: OffboardingReason | undefined;
    remarks?: string | undefined;
}

export class OnboardingRequestDto implements IOnboardingRequestDto {
    id?: number;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    locationName?: string | undefined;
    departmentName?: string | undefined;
    designation?: string | undefined;
    employmentDate?: Date | undefined;
    status?: RequestStatus;
    submittedBy?: string | undefined;
    submittedDate?: Date | undefined;
    firstApprovalDate?: Date | undefined;
    secondApprovalDate?: Date | undefined;
    totalTasks?: number;
    completedTasks?: number;

    constructor(data?: IOnboardingRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.locationName = _data["locationName"];
            this.departmentName = _data["departmentName"];
            this.designation = _data["designation"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.submittedBy = _data["submittedBy"];
            this.submittedDate = _data["submittedDate"] ? new Date(_data["submittedDate"].toString()) : <any>undefined;
            this.firstApprovalDate = _data["firstApprovalDate"] ? new Date(_data["firstApprovalDate"].toString()) : <any>undefined;
            this.secondApprovalDate = _data["secondApprovalDate"] ? new Date(_data["secondApprovalDate"].toString()) : <any>undefined;
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
        }
    }

    static fromJS(data: any): OnboardingRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["locationName"] = this.locationName;
        data["departmentName"] = this.departmentName;
        data["designation"] = this.designation;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["submittedBy"] = this.submittedBy;
        data["submittedDate"] = this.submittedDate ? this.submittedDate.toISOString() : <any>undefined;
        data["firstApprovalDate"] = this.firstApprovalDate ? this.firstApprovalDate.toISOString() : <any>undefined;
        data["secondApprovalDate"] = this.secondApprovalDate ? this.secondApprovalDate.toISOString() : <any>undefined;
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IOnboardingRequestDto {
    id?: number;
    employeeId?: number | undefined;
    employeeName?: string | undefined;
    locationName?: string | undefined;
    departmentName?: string | undefined;
    designation?: string | undefined;
    employmentDate?: Date | undefined;
    status?: RequestStatus;
    submittedBy?: string | undefined;
    submittedDate?: Date | undefined;
    firstApprovalDate?: Date | undefined;
    secondApprovalDate?: Date | undefined;
    totalTasks?: number;
    completedTasks?: number;
}

export class CreateOnboardingRequestCommand implements ICreateOnboardingRequestCommand {
    employeeId?: number;
    requiresHardware?: boolean;
    remarks?: string | undefined;
    department?: string;

    constructor(data?: ICreateOnboardingRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.requiresHardware = _data["requiresHardware"];
            this.remarks = _data["remarks"];
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): CreateOnboardingRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOnboardingRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["requiresHardware"] = this.requiresHardware;
        data["remarks"] = this.remarks;
        data["department"] = this.department;
        return data;
    }
}

export interface ICreateOnboardingRequestCommand {
    employeeId?: number;
    requiresHardware?: boolean;
    remarks?: string | undefined;
    department?: string;
}

export class InitializeOnboardingRequestCommand implements IInitializeOnboardingRequestCommand {
    employeeName?: string;
    locationId?: number;
    departmentId?: number;
    designation?: string;
    personalEmail?: string;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;

    constructor(data?: IInitializeOnboardingRequestCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeName = _data["employeeName"];
            this.locationId = _data["locationId"];
            this.departmentId = _data["departmentId"];
            this.designation = _data["designation"];
            this.personalEmail = _data["personalEmail"];
            this.immediateSuperiorEmail = _data["immediateSuperiorEmail"];
            this.reportingSuperiorEmail = _data["reportingSuperiorEmail"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InitializeOnboardingRequestCommand {
        data = typeof data === 'object' ? data : {};
        let result = new InitializeOnboardingRequestCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeName"] = this.employeeName;
        data["locationId"] = this.locationId;
        data["departmentId"] = this.departmentId;
        data["designation"] = this.designation;
        data["personalEmail"] = this.personalEmail;
        data["immediateSuperiorEmail"] = this.immediateSuperiorEmail;
        data["reportingSuperiorEmail"] = this.reportingSuperiorEmail;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IInitializeOnboardingRequestCommand {
    employeeName?: string;
    locationId?: number;
    departmentId?: number;
    designation?: string;
    personalEmail?: string;
    immediateSuperiorEmail?: string | undefined;
    reportingSuperiorEmail?: string | undefined;
    employmentDate?: Date;
}

export class ApplyTemplateRequest implements IApplyTemplateRequest {
    templateId?: number;

    constructor(data?: IApplyTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
        }
    }

    static fromJS(data: any): ApplyTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApplyTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        return data;
    }
}

export interface IApplyTemplateRequest {
    templateId?: number;
}

export class AddPostOnboardingTaskCommand implements IAddPostOnboardingTaskCommand {
    onboardingRequestId?: number;
    templateTaskId?: number;
    assetName?: string | undefined;
    assetValue?: string | undefined;
    teamId?: number | undefined;
    picId?: string | undefined;

    constructor(data?: IAddPostOnboardingTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.onboardingRequestId = _data["onboardingRequestId"];
            this.templateTaskId = _data["templateTaskId"];
            this.assetName = _data["assetName"];
            this.assetValue = _data["assetValue"];
            this.teamId = _data["teamId"];
            this.picId = _data["picId"];
        }
    }

    static fromJS(data: any): AddPostOnboardingTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddPostOnboardingTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["onboardingRequestId"] = this.onboardingRequestId;
        data["templateTaskId"] = this.templateTaskId;
        data["assetName"] = this.assetName;
        data["assetValue"] = this.assetValue;
        data["teamId"] = this.teamId;
        data["picId"] = this.picId;
        return data;
    }
}

export interface IAddPostOnboardingTaskCommand {
    onboardingRequestId?: number;
    templateTaskId?: number;
    assetName?: string | undefined;
    assetValue?: string | undefined;
    teamId?: number | undefined;
    picId?: string | undefined;
}

export class OnboardingRequestPreviewDto implements IOnboardingRequestPreviewDto {
    boardingRequestId?: number;
    status?: RequestStatus;
    employee?: EmployeePreviewDto;
    categories?: RequestItemCategoryDto[];
    firstApprovalId?: number | undefined;
    firstApprovalDate?: Date | undefined;
    secondApprovalId?: number | undefined;
    secondApprovalDate?: Date | undefined;
    totalTasks?: number;
    completedTasks?: number;

    constructor(data?: IOnboardingRequestPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardingRequestId = _data["boardingRequestId"];
            this.status = _data["status"];
            this.employee = _data["employee"] ? EmployeePreviewDto.fromJS(_data["employee"]) : <any>undefined;
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(RequestItemCategoryDto.fromJS(item));
            }
            this.firstApprovalId = _data["firstApprovalId"];
            this.firstApprovalDate = _data["firstApprovalDate"] ? new Date(_data["firstApprovalDate"].toString()) : <any>undefined;
            this.secondApprovalId = _data["secondApprovalId"];
            this.secondApprovalDate = _data["secondApprovalDate"] ? new Date(_data["secondApprovalDate"].toString()) : <any>undefined;
            this.totalTasks = _data["totalTasks"];
            this.completedTasks = _data["completedTasks"];
        }
    }

    static fromJS(data: any): OnboardingRequestPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OnboardingRequestPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardingRequestId"] = this.boardingRequestId;
        data["status"] = this.status;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        data["firstApprovalId"] = this.firstApprovalId;
        data["firstApprovalDate"] = this.firstApprovalDate ? this.firstApprovalDate.toISOString() : <any>undefined;
        data["secondApprovalId"] = this.secondApprovalId;
        data["secondApprovalDate"] = this.secondApprovalDate ? this.secondApprovalDate.toISOString() : <any>undefined;
        data["totalTasks"] = this.totalTasks;
        data["completedTasks"] = this.completedTasks;
        return data;
    }
}

export interface IOnboardingRequestPreviewDto {
    boardingRequestId?: number;
    status?: RequestStatus;
    employee?: EmployeePreviewDto;
    categories?: RequestItemCategoryDto[];
    firstApprovalId?: number | undefined;
    firstApprovalDate?: Date | undefined;
    secondApprovalId?: number | undefined;
    secondApprovalDate?: Date | undefined;
    totalTasks?: number;
    completedTasks?: number;
}

export class RequestItemCategoryDto implements IRequestItemCategoryDto {
    categoryId?: number;
    categoryName?: string;
    displayOrder?: number;
    items?: RequestItemPreviewDto[];

    constructor(data?: IRequestItemCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"];
            this.categoryName = _data["categoryName"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RequestItemPreviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RequestItemCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestItemCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId;
        data["categoryName"] = this.categoryName;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRequestItemCategoryDto {
    categoryId?: number;
    categoryName?: string;
    displayOrder?: number;
    items?: RequestItemPreviewDto[];
}

export class RequestItemPreviewDto implements IRequestItemPreviewDto {
    id?: number;
    itemName?: string;
    description?: string | undefined;
    status?: RequestItemStatus;
    displayOrder?: number;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    approvedDate?: Date | undefined;
    approvalStatus?: ApprovalStatus | undefined;
    itemApprovalId?: number | undefined;
    rejectionReason?: string | undefined;
    rejectionDate?: Date | undefined;
    picId?: string | undefined;
    teamId?: number | undefined;
    assignedPersonName?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedAsset?: string | undefined;
    dueDate?: Date | undefined;
    templateTaskId?: number | undefined;
    phase?: TaskPhase;
    latestRemark?: string | undefined;
    latestRemarkDate?: Date | undefined;

    constructor(data?: IRequestItemPreviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.displayOrder = _data["displayOrder"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.approvalStatus = _data["approvalStatus"];
            this.itemApprovalId = _data["itemApprovalId"];
            this.rejectionReason = _data["rejectionReason"];
            this.rejectionDate = _data["rejectionDate"] ? new Date(_data["rejectionDate"].toString()) : <any>undefined;
            this.picId = _data["picId"];
            this.teamId = _data["teamId"];
            this.assignedPersonName = _data["assignedPersonName"];
            this.assignedTeamName = _data["assignedTeamName"];
            this.assignedAsset = _data["assignedAsset"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.templateTaskId = _data["templateTaskId"];
            this.phase = _data["phase"];
            this.latestRemark = _data["latestRemark"];
            this.latestRemarkDate = _data["latestRemarkDate"] ? new Date(_data["latestRemarkDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestItemPreviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestItemPreviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["displayOrder"] = this.displayOrder;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["approvalStatus"] = this.approvalStatus;
        data["itemApprovalId"] = this.itemApprovalId;
        data["rejectionReason"] = this.rejectionReason;
        data["rejectionDate"] = this.rejectionDate ? this.rejectionDate.toISOString() : <any>undefined;
        data["picId"] = this.picId;
        data["teamId"] = this.teamId;
        data["assignedPersonName"] = this.assignedPersonName;
        data["assignedTeamName"] = this.assignedTeamName;
        data["assignedAsset"] = this.assignedAsset;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["templateTaskId"] = this.templateTaskId;
        data["phase"] = this.phase;
        data["latestRemark"] = this.latestRemark;
        data["latestRemarkDate"] = this.latestRemarkDate ? this.latestRemarkDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRequestItemPreviewDto {
    id?: number;
    itemName?: string;
    description?: string | undefined;
    status?: RequestItemStatus;
    displayOrder?: number;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    approvedDate?: Date | undefined;
    approvalStatus?: ApprovalStatus | undefined;
    itemApprovalId?: number | undefined;
    rejectionReason?: string | undefined;
    rejectionDate?: Date | undefined;
    picId?: string | undefined;
    teamId?: number | undefined;
    assignedPersonName?: string | undefined;
    assignedTeamName?: string | undefined;
    assignedAsset?: string | undefined;
    dueDate?: Date | undefined;
    templateTaskId?: number | undefined;
    phase?: TaskPhase;
    latestRemark?: string | undefined;
    latestRemarkDate?: Date | undefined;
}

export enum ApprovalStatus {
    Pending = 0,
    Approved = 1,
    Rejected = 2,
    Expired = 3,
}

export class DeclineOnboardingRequestRequest implements IDeclineOnboardingRequestRequest {
    reason?: string | undefined;

    constructor(data?: IDeclineOnboardingRequestRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DeclineOnboardingRequestRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeclineOnboardingRequestRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason;
        return data;
    }
}

export interface IDeclineOnboardingRequestRequest {
    reason?: string | undefined;
}

export class PayrollCompanyDto implements IPayrollCompanyDto {
    id?: number;
    name?: string;

    constructor(data?: IPayrollCompanyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PayrollCompanyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayrollCompanyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IPayrollCompanyDto {
    id?: number;
    name?: string;
}

export class CreatePayrollCompanyCommand implements ICreatePayrollCompanyCommand {
    name?: string;

    constructor(data?: ICreatePayrollCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePayrollCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePayrollCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICreatePayrollCompanyCommand {
    name?: string;
}

export class UpdatePayrollCompanyCommand implements IUpdatePayrollCompanyCommand {
    id?: number;
    name?: string;

    constructor(data?: IUpdatePayrollCompanyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdatePayrollCompanyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePayrollCompanyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUpdatePayrollCompanyCommand {
    id?: number;
    name?: string;
}

export class PicTaskDto implements IPicTaskDto {
    taskId?: number;
    taskName?: string;
    description?: string | undefined;
    status?: RequestItemStatus;
    dueDate?: Date | undefined;
    displayOrder?: number;
    remarks?: string | undefined;
    assignedAsset?: string | undefined;
    approvedDate?: Date | undefined;
    completedDate?: Date | undefined;
    category?: string | undefined;
    boardingRequestId?: number;
    requestType?: RequestType;
    requestStatus?: RequestStatus;
    requestSubmittedDate?: Date;
    requestDueDate?: Date | undefined;
    requestRemarks?: string | undefined;
    requiresHardware?: boolean;
    employeeId?: number;
    employeeName?: string;
    employeeNumber?: string | undefined;
    employeeDesignation?: string | undefined;
    employeeEmail?: string | undefined;
    employeeDepartment?: string | undefined;
    employeeLocation?: string | undefined;
    employmentDate?: Date | undefined;

    constructor(data?: IPicTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskId = _data["taskId"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.displayOrder = _data["displayOrder"];
            this.remarks = _data["remarks"];
            this.assignedAsset = _data["assignedAsset"];
            this.approvedDate = _data["approvedDate"] ? new Date(_data["approvedDate"].toString()) : <any>undefined;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : <any>undefined;
            this.category = _data["category"];
            this.boardingRequestId = _data["boardingRequestId"];
            this.requestType = _data["requestType"];
            this.requestStatus = _data["requestStatus"];
            this.requestSubmittedDate = _data["requestSubmittedDate"] ? new Date(_data["requestSubmittedDate"].toString()) : <any>undefined;
            this.requestDueDate = _data["requestDueDate"] ? new Date(_data["requestDueDate"].toString()) : <any>undefined;
            this.requestRemarks = _data["requestRemarks"];
            this.requiresHardware = _data["requiresHardware"];
            this.employeeId = _data["employeeId"];
            this.employeeName = _data["employeeName"];
            this.employeeNumber = _data["employeeNumber"];
            this.employeeDesignation = _data["employeeDesignation"];
            this.employeeEmail = _data["employeeEmail"];
            this.employeeDepartment = _data["employeeDepartment"];
            this.employeeLocation = _data["employeeLocation"];
            this.employmentDate = _data["employmentDate"] ? new Date(_data["employmentDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PicTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new PicTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskId"] = this.taskId;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["status"] = this.status;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["displayOrder"] = this.displayOrder;
        data["remarks"] = this.remarks;
        data["assignedAsset"] = this.assignedAsset;
        data["approvedDate"] = this.approvedDate ? this.approvedDate.toISOString() : <any>undefined;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : <any>undefined;
        data["category"] = this.category;
        data["boardingRequestId"] = this.boardingRequestId;
        data["requestType"] = this.requestType;
        data["requestStatus"] = this.requestStatus;
        data["requestSubmittedDate"] = this.requestSubmittedDate ? this.requestSubmittedDate.toISOString() : <any>undefined;
        data["requestDueDate"] = this.requestDueDate ? this.requestDueDate.toISOString() : <any>undefined;
        data["requestRemarks"] = this.requestRemarks;
        data["requiresHardware"] = this.requiresHardware;
        data["employeeId"] = this.employeeId;
        data["employeeName"] = this.employeeName;
        data["employeeNumber"] = this.employeeNumber;
        data["employeeDesignation"] = this.employeeDesignation;
        data["employeeEmail"] = this.employeeEmail;
        data["employeeDepartment"] = this.employeeDepartment;
        data["employeeLocation"] = this.employeeLocation;
        data["employmentDate"] = this.employmentDate ? this.employmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPicTaskDto {
    taskId?: number;
    taskName?: string;
    description?: string | undefined;
    status?: RequestItemStatus;
    dueDate?: Date | undefined;
    displayOrder?: number;
    remarks?: string | undefined;
    assignedAsset?: string | undefined;
    approvedDate?: Date | undefined;
    completedDate?: Date | undefined;
    category?: string | undefined;
    boardingRequestId?: number;
    requestType?: RequestType;
    requestStatus?: RequestStatus;
    requestSubmittedDate?: Date;
    requestDueDate?: Date | undefined;
    requestRemarks?: string | undefined;
    requiresHardware?: boolean;
    employeeId?: number;
    employeeName?: string;
    employeeNumber?: string | undefined;
    employeeDesignation?: string | undefined;
    employeeEmail?: string | undefined;
    employeeDepartment?: string | undefined;
    employeeLocation?: string | undefined;
    employmentDate?: Date | undefined;
}

export enum RequestType {
    Onboarding = 1,
    Offboarding = 2,
}

export class AddCustomRequestItemCommand implements IAddCustomRequestItemCommand {
    boardingRequestId?: number;
    itemName?: string;
    description?: string | undefined;
    picId?: string | undefined;
    teamId?: number | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    templateCategoryId?: number | undefined;
    offboardingAction?: OffboardingAction | undefined;

    constructor(data?: IAddCustomRequestItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.boardingRequestId = _data["boardingRequestId"];
            this.itemName = _data["itemName"];
            this.description = _data["description"];
            this.picId = _data["picId"];
            this.teamId = _data["teamId"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
            this.templateCategoryId = _data["templateCategoryId"];
            this.offboardingAction = _data["offboardingAction"];
        }
    }

    static fromJS(data: any): AddCustomRequestItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomRequestItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["boardingRequestId"] = this.boardingRequestId;
        data["itemName"] = this.itemName;
        data["description"] = this.description;
        data["picId"] = this.picId;
        data["teamId"] = this.teamId;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        data["templateCategoryId"] = this.templateCategoryId;
        data["offboardingAction"] = this.offboardingAction;
        return data;
    }
}

export interface IAddCustomRequestItemCommand {
    boardingRequestId?: number;
    itemName?: string;
    description?: string | undefined;
    picId?: string | undefined;
    teamId?: number | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    templateCategoryId?: number | undefined;
    offboardingAction?: OffboardingAction | undefined;
}

export class UpdateRequestItemPicRequest implements IUpdateRequestItemPicRequest {
    picId?: string | undefined;
    teamId?: number | undefined;
    requiresApproval?: boolean | undefined;
    approverEmail?: string | undefined;

    constructor(data?: IUpdateRequestItemPicRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.picId = _data["picId"];
            this.teamId = _data["teamId"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
        }
    }

    static fromJS(data: any): UpdateRequestItemPicRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestItemPicRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["picId"] = this.picId;
        data["teamId"] = this.teamId;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        return data;
    }
}

export interface IUpdateRequestItemPicRequest {
    picId?: string | undefined;
    teamId?: number | undefined;
    requiresApproval?: boolean | undefined;
    approverEmail?: string | undefined;
}

export class ApproveRequestItemRequest implements IApproveRequestItemRequest {
    userEmail?: string;
    remarks?: string | undefined;

    constructor(data?: IApproveRequestItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): ApproveRequestItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveRequestItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IApproveRequestItemRequest {
    userEmail?: string;
    remarks?: string | undefined;
}

export class UpdateRequestItemStatusRequest implements IUpdateRequestItemStatusRequest {
    status?: RequestItemStatus;
    remarks?: string | undefined;
    offboardingAction?: OffboardingAction | undefined;
    extendedUntil?: Date | undefined;

    constructor(data?: IUpdateRequestItemStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.remarks = _data["remarks"];
            this.offboardingAction = _data["offboardingAction"];
            this.extendedUntil = _data["extendedUntil"] ? new Date(_data["extendedUntil"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateRequestItemStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequestItemStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["remarks"] = this.remarks;
        data["offboardingAction"] = this.offboardingAction;
        data["extendedUntil"] = this.extendedUntil ? this.extendedUntil.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUpdateRequestItemStatusRequest {
    status?: RequestItemStatus;
    remarks?: string | undefined;
    offboardingAction?: OffboardingAction | undefined;
    extendedUntil?: Date | undefined;
}

export class AssignAssetRequest implements IAssignAssetRequest {
    assetName?: string;
    assetValue?: string | undefined;

    constructor(data?: IAssignAssetRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetName = _data["assetName"];
            this.assetValue = _data["assetValue"];
        }
    }

    static fromJS(data: any): AssignAssetRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignAssetRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetName"] = this.assetName;
        data["assetValue"] = this.assetValue;
        return data;
    }
}

export interface IAssignAssetRequest {
    assetName?: string;
    assetValue?: string | undefined;
}

export class ReassignRequestItemRequest implements IReassignRequestItemRequest {
    newPicId?: string;
    reason?: string | undefined;

    constructor(data?: IReassignRequestItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPicId = _data["newPicId"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ReassignRequestItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReassignRequestItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPicId"] = this.newPicId;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IReassignRequestItemRequest {
    newPicId?: string;
    reason?: string | undefined;
}

export class AddRemarkRequest implements IAddRemarkRequest {
    remark?: string;

    constructor(data?: IAddRemarkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.remark = _data["remark"];
        }
    }

    static fromJS(data: any): AddRemarkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRemarkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["remark"] = this.remark;
        return data;
    }
}

export interface IAddRemarkRequest {
    remark?: string;
}

export class RequestItemLogDto implements IRequestItemLogDto {
    id?: number;
    action?: string;
    performedBy?: string;
    performedByEmail?: string | undefined;
    created?: Date;
    oldValues?: string | undefined;
    newValues?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: IRequestItemLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.action = _data["action"];
            this.performedBy = _data["performedBy"];
            this.performedByEmail = _data["performedByEmail"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.oldValues = _data["oldValues"];
            this.newValues = _data["newValues"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): RequestItemLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestItemLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["action"] = this.action;
        data["performedBy"] = this.performedBy;
        data["performedByEmail"] = this.performedByEmail;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["oldValues"] = this.oldValues;
        data["newValues"] = this.newValues;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface IRequestItemLogDto {
    id?: number;
    action?: string;
    performedBy?: string;
    performedByEmail?: string | undefined;
    created?: Date;
    oldValues?: string | undefined;
    newValues?: string | undefined;
    remarks?: string | undefined;
}

export class TeamDto implements ITeamDto {
    id?: number;
    name?: string;
    description?: string | undefined;
    isActive?: boolean;
    memberCount?: number;

    constructor(data?: ITeamDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isActive = _data["isActive"];
            this.memberCount = _data["memberCount"];
        }
    }

    static fromJS(data: any): TeamDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isActive"] = this.isActive;
        data["memberCount"] = this.memberCount;
        return data;
    }
}

export interface ITeamDto {
    id?: number;
    name?: string;
    description?: string | undefined;
    isActive?: boolean;
    memberCount?: number;
}

export class TeamMemberDto implements ITeamMemberDto {
    id?: number;
    teamId?: number;
    userId?: string;
    userName?: string | undefined;
    userEmail?: string | undefined;
    joinedDate?: Date;
    isActive?: boolean;

    constructor(data?: ITeamMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teamId = _data["teamId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userEmail = _data["userEmail"];
            this.joinedDate = _data["joinedDate"] ? new Date(_data["joinedDate"].toString()) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TeamMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teamId"] = this.teamId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userEmail"] = this.userEmail;
        data["joinedDate"] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITeamMemberDto {
    id?: number;
    teamId?: number;
    userId?: string;
    userName?: string | undefined;
    userEmail?: string | undefined;
    joinedDate?: Date;
    isActive?: boolean;
}

export class CreateTeamCommand implements ICreateTeamCommand {
    name?: string;
    description?: string | undefined;

    constructor(data?: ICreateTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateTeamCommand {
    name?: string;
    description?: string | undefined;
}

export class AddTeamMemberCommand implements IAddTeamMemberCommand {
    teamId?: number;
    userId?: string;

    constructor(data?: IAddTeamMemberCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamId = _data["teamId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AddTeamMemberCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AddTeamMemberCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamId"] = this.teamId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IAddTeamMemberCommand {
    teamId?: number;
    userId?: string;
}

export class UpdateTeamCommand implements IUpdateTeamCommand {
    id?: number;
    name?: string;
    description?: string | undefined;

    constructor(data?: IUpdateTeamCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateTeamCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }
}

export interface IUpdateTeamCommand {
    id?: number;
    name?: string;
    description?: string | undefined;
}

export class TemplateCategoryListDto implements ITemplateCategoryListDto {
    id?: number;
    name?: string;
    displayOrder?: number;
    isActive?: boolean;
    taskCount?: number;

    constructor(data?: ITemplateCategoryListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
            this.taskCount = _data["taskCount"];
        }
    }

    static fromJS(data: any): TemplateCategoryListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCategoryListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        data["taskCount"] = this.taskCount;
        return data;
    }
}

export interface ITemplateCategoryListDto {
    id?: number;
    name?: string;
    displayOrder?: number;
    isActive?: boolean;
    taskCount?: number;
}

export class CreateTemplateCategoryCommand implements ICreateTemplateCategoryCommand {
    name?: string;
    displayOrder?: number;

    constructor(data?: ICreateTemplateCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
        }
    }

    static fromJS(data: any): CreateTemplateCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        return data;
    }
}

export interface ICreateTemplateCategoryCommand {
    name?: string;
    displayOrder?: number;
}

export class UpdateTemplateCategoryCommand implements IUpdateTemplateCategoryCommand {
    id?: number;
    name?: string;
    displayOrder?: number;
    isActive?: boolean;

    constructor(data?: IUpdateTemplateCategoryCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTemplateCategoryCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCategoryCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTemplateCategoryCommand {
    id?: number;
    name?: string;
    displayOrder?: number;
    isActive?: boolean;
}

export class TemplateDto implements ITemplateDto {
    id?: number;
    templateName?: string;
    description?: string | undefined;
    categories?: TemplateCategoryDto[];

    constructor(data?: ITemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(TemplateCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateDto {
    id?: number;
    templateName?: string;
    description?: string | undefined;
    categories?: TemplateCategoryDto[];
}

export class TemplateCategoryDto implements ITemplateCategoryDto {
    id?: number;
    name?: string;
    displayOrder?: number;
    tasks?: TemplateTaskDto[];

    constructor(data?: ITemplateCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayOrder = _data["displayOrder"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TemplateTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TemplateCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayOrder"] = this.displayOrder;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITemplateCategoryDto {
    id?: number;
    name?: string;
    displayOrder?: number;
    tasks?: TemplateTaskDto[];
}

export class TemplateTaskDto implements ITemplateTaskDto {
    id?: number | undefined;
    taskName?: string;
    description?: string | undefined;
    displayOrder?: number | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    templateCategoryId?: number | undefined;
    isActive?: boolean;

    constructor(data?: ITemplateTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
            this.defaultPicId = _data["defaultPicId"];
            this.defaultTeamId = _data["defaultTeamId"];
            this.templateCategoryId = _data["templateCategoryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TemplateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        data["defaultPicId"] = this.defaultPicId;
        data["defaultTeamId"] = this.defaultTeamId;
        data["templateCategoryId"] = this.templateCategoryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITemplateTaskDto {
    id?: number | undefined;
    taskName?: string;
    description?: string | undefined;
    displayOrder?: number | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    templateCategoryId?: number | undefined;
    isActive?: boolean;
}

export class TemplateListDto implements ITemplateListDto {
    id?: number;
    templateName?: string;
    description?: string | undefined;
    requestType?: RequestType;
    taskCount?: number;
    isActive?: boolean;

    constructor(data?: ITemplateListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.requestType = _data["requestType"];
            this.taskCount = _data["taskCount"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TemplateListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["requestType"] = this.requestType;
        data["taskCount"] = this.taskCount;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface ITemplateListDto {
    id?: number;
    templateName?: string;
    description?: string | undefined;
    requestType?: RequestType;
    taskCount?: number;
    isActive?: boolean;
}

export class CreateTemplateCommand implements ICreateTemplateCommand {
    templateName?: string;
    description?: string | undefined;
    requestType?: RequestType;
    templateTasks?: TemplateTaskDto[];

    constructor(data?: ICreateTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.requestType = _data["requestType"];
            if (Array.isArray(_data["templateTasks"])) {
                this.templateTasks = [] as any;
                for (let item of _data["templateTasks"])
                    this.templateTasks!.push(TemplateTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["requestType"] = this.requestType;
        if (Array.isArray(this.templateTasks)) {
            data["templateTasks"] = [];
            for (let item of this.templateTasks)
                data["templateTasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateTemplateCommand {
    templateName?: string;
    description?: string | undefined;
    requestType?: RequestType;
    templateTasks?: TemplateTaskDto[];
}

export class UpdateTemplateCommand implements IUpdateTemplateCommand {
    id?: number;
    templateName?: string;
    description?: string | undefined;
    requestType?: RequestType;
    tasks?: TemplateTaskDto[];

    constructor(data?: IUpdateTemplateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.description = _data["description"];
            this.requestType = _data["requestType"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(TemplateTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTemplateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["description"] = this.description;
        data["requestType"] = this.requestType;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTemplateCommand {
    id?: number;
    templateName?: string;
    description?: string | undefined;
    requestType?: RequestType;
    tasks?: TemplateTaskDto[];
}

export class TemplateTaskListDto implements ITemplateTaskListDto {
    id?: number;
    taskName?: string;
    description?: string | undefined;
    displayOrder?: number | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultApproverId?: number | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    isActive?: boolean;
    templateCategoryId?: number | undefined;
    templateCategoryName?: string | undefined;

    constructor(data?: ITemplateTaskListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.displayOrder = _data["displayOrder"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
            this.defaultApproverId = _data["defaultApproverId"];
            this.defaultPicId = _data["defaultPicId"];
            this.defaultTeamId = _data["defaultTeamId"];
            this.isActive = _data["isActive"];
            this.templateCategoryId = _data["templateCategoryId"];
            this.templateCategoryName = _data["templateCategoryName"];
        }
    }

    static fromJS(data: any): TemplateTaskListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateTaskListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["displayOrder"] = this.displayOrder;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        data["defaultApproverId"] = this.defaultApproverId;
        data["defaultPicId"] = this.defaultPicId;
        data["defaultTeamId"] = this.defaultTeamId;
        data["isActive"] = this.isActive;
        data["templateCategoryId"] = this.templateCategoryId;
        data["templateCategoryName"] = this.templateCategoryName;
        return data;
    }
}

export interface ITemplateTaskListDto {
    id?: number;
    taskName?: string;
    description?: string | undefined;
    displayOrder?: number | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultApproverId?: number | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    isActive?: boolean;
    templateCategoryId?: number | undefined;
    templateCategoryName?: string | undefined;
}

export class CreateTemplateTaskCommand implements ICreateTemplateTaskCommand {
    taskName?: string;
    description?: string | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    templateCategoryId?: number | undefined;

    constructor(data?: ICreateTemplateTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
            this.defaultPicId = _data["defaultPicId"];
            this.defaultTeamId = _data["defaultTeamId"];
            this.templateCategoryId = _data["templateCategoryId"];
        }
    }

    static fromJS(data: any): CreateTemplateTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTemplateTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        data["defaultPicId"] = this.defaultPicId;
        data["defaultTeamId"] = this.defaultTeamId;
        data["templateCategoryId"] = this.templateCategoryId;
        return data;
    }
}

export interface ICreateTemplateTaskCommand {
    taskName?: string;
    description?: string | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    templateCategoryId?: number | undefined;
}

export class UpdateTemplateTaskCommand implements IUpdateTemplateTaskCommand {
    id?: number;
    taskName?: string;
    description?: string | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    templateCategoryId?: number | undefined;
    isActive?: boolean;

    constructor(data?: IUpdateTemplateTaskCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskName = _data["taskName"];
            this.description = _data["description"];
            this.requiresApproval = _data["requiresApproval"];
            this.approverEmail = _data["approverEmail"];
            this.defaultPicId = _data["defaultPicId"];
            this.defaultTeamId = _data["defaultTeamId"];
            this.templateCategoryId = _data["templateCategoryId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateTemplateTaskCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTemplateTaskCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskName"] = this.taskName;
        data["description"] = this.description;
        data["requiresApproval"] = this.requiresApproval;
        data["approverEmail"] = this.approverEmail;
        data["defaultPicId"] = this.defaultPicId;
        data["defaultTeamId"] = this.defaultTeamId;
        data["templateCategoryId"] = this.templateCategoryId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUpdateTemplateTaskCommand {
    id?: number;
    taskName?: string;
    description?: string | undefined;
    requiresApproval?: boolean;
    approverEmail?: string | undefined;
    defaultPicId?: string | undefined;
    defaultTeamId?: number | undefined;
    templateCategoryId?: number | undefined;
    isActive?: boolean;
}

export class PaginatedListOfTodoItemBriefDto implements IPaginatedListOfTodoItemBriefDto {
    items?: TodoItemBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;

    constructor(data?: IPaginatedListOfTodoItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemBriefDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.totalPages = _data["totalPages"];
            this.totalCount = _data["totalCount"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTodoItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTodoItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["totalPages"] = this.totalPages;
        data["totalCount"] = this.totalCount;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }
}

export interface IPaginatedListOfTodoItemBriefDto {
    items?: TodoItemBriefDto[];
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export class TodoItemBriefDto implements ITodoItemBriefDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: ITodoItemBriefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): TodoItemBriefDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemBriefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    }
}

export interface ITodoItemBriefDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
}

export class CreateTodoItemCommand implements ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;

    constructor(data?: ICreateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.listId = _data["listId"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listId"] = this.listId;
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateTodoItemCommand {
    listId?: number;
    title?: string | undefined;
}

export class UpdateTodoItemCommand implements IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;

    constructor(data?: IUpdateTodoItemCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.done = _data["done"];
        }
    }

    static fromJS(data: any): UpdateTodoItemCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["done"] = this.done;
        return data;
    }
}

export interface IUpdateTodoItemCommand {
    id?: number;
    title?: string | undefined;
    done?: boolean;
}

export class UpdateTodoItemDetailCommand implements IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;

    constructor(data?: IUpdateTodoItemDetailCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateTodoItemDetailCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoItemDetailCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface IUpdateTodoItemDetailCommand {
    id?: number;
    listId?: number;
    priority?: PriorityLevel;
    note?: string | undefined;
}

export enum PriorityLevel {
    None = 0,
    Low = 1,
    Medium = 2,
    High = 3,
}

export class TodosVm implements ITodosVm {
    priorityLevels?: LookupDto[];
    lists?: TodoListDto[];

    constructor(data?: ITodosVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["priorityLevels"])) {
                this.priorityLevels = [] as any;
                for (let item of _data["priorityLevels"])
                    this.priorityLevels!.push(LookupDto.fromJS(item));
            }
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(TodoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodosVm {
        data = typeof data === 'object' ? data : {};
        let result = new TodosVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.priorityLevels)) {
            data["priorityLevels"] = [];
            for (let item of this.priorityLevels)
                data["priorityLevels"].push(item.toJSON());
        }
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITodosVm {
    priorityLevels?: LookupDto[];
    lists?: TodoListDto[];
}

export class LookupDto implements ILookupDto {
    id?: number;
    title?: string | undefined;

    constructor(data?: ILookupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): LookupDto {
        data = typeof data === 'object' ? data : {};
        let result = new LookupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface ILookupDto {
    id?: number;
    title?: string | undefined;
}

export class TodoListDto implements ITodoListDto {
    id?: number;
    title?: string | undefined;
    colour?: string | undefined;
    items?: TodoItemDto[];

    constructor(data?: ITodoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.colour = _data["colour"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TodoItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TodoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["colour"] = this.colour;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITodoListDto {
    id?: number;
    title?: string | undefined;
    colour?: string | undefined;
    items?: TodoItemDto[];
}

export class TodoItemDto implements ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;

    constructor(data?: ITodoItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.listId = _data["listId"];
            this.title = _data["title"];
            this.done = _data["done"];
            this.priority = _data["priority"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): TodoItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TodoItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["listId"] = this.listId;
        data["title"] = this.title;
        data["done"] = this.done;
        data["priority"] = this.priority;
        data["note"] = this.note;
        return data;
    }
}

export interface ITodoItemDto {
    id?: number;
    listId?: number;
    title?: string | undefined;
    done?: boolean;
    priority?: number;
    note?: string | undefined;
}

export class CreateTodoListCommand implements ICreateTodoListCommand {
    title?: string | undefined;

    constructor(data?: ICreateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }
}

export interface ICreateTodoListCommand {
    title?: string | undefined;
}

export class UpdateTodoListCommand implements IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;

    constructor(data?: IUpdateTodoListCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateTodoListCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTodoListCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface IUpdateTodoListCommand {
    id?: number;
    title?: string | undefined;
}

export class RedirectResponse implements IRedirectResponse {
    redirectUrl?: string | undefined;

    constructor(data?: IRedirectResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.redirectUrl = _data["redirectUrl"];
        }
    }

    static fromJS(data: any): RedirectResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["redirectUrl"] = this.redirectUrl;
        return data;
    }
}

export interface IRedirectResponse {
    redirectUrl?: string | undefined;
}

export class LoginRequest implements ILoginRequest {
    email?: string;
    password?: string;
    twoFactorCode?: string | undefined;
    twoFactorRecoveryCode?: string | undefined;

    constructor(data?: ILoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.twoFactorCode = _data["twoFactorCode"];
            this.twoFactorRecoveryCode = _data["twoFactorRecoveryCode"];
        }
    }

    static fromJS(data: any): LoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["twoFactorCode"] = this.twoFactorCode;
        data["twoFactorRecoveryCode"] = this.twoFactorRecoveryCode;
        return data;
    }
}

export interface ILoginRequest {
    email?: string;
    password?: string;
    twoFactorCode?: string | undefined;
    twoFactorRecoveryCode?: string | undefined;
}

export class AccessTokenResponse implements IAccessTokenResponse {
    tokenType?: string;
    accessToken?: string;
    expiresIn?: number;
    refreshToken?: string;

    constructor(data?: IAccessTokenResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenType = _data["tokenType"];
            this.accessToken = _data["accessToken"];
            this.expiresIn = _data["expiresIn"];
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): AccessTokenResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccessTokenResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenType"] = this.tokenType;
        data["accessToken"] = this.accessToken;
        data["expiresIn"] = this.expiresIn;
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IAccessTokenResponse {
    tokenType?: string;
    accessToken?: string;
    expiresIn?: number;
    refreshToken?: string;
}

export class RefreshRequest implements IRefreshRequest {
    refreshToken?: string;

    constructor(data?: IRefreshRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }

    static fromJS(data: any): RefreshRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}

export interface IRefreshRequest {
    refreshToken?: string;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email?: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordRequest {
    email?: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static override fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; };

    [key: string]: any;
}

export class RegisterRequest implements IRegisterRequest {
    email?: string;
    password?: string;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IRegisterRequest {
    email?: string;
    password?: string;
}

export class ApplicationUserDto implements IApplicationUserDto {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    isActive?: boolean;
    isArchived?: boolean;
    createdAt?: Date | undefined;
    isKeySeniorEmployee?: number;
    roles?: string[];

    constructor(data?: IApplicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            this.isActive = _data["isActive"];
            this.isArchived = _data["isArchived"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isKeySeniorEmployee = _data["isKeySeniorEmployee"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        data["isActive"] = this.isActive;
        data["isArchived"] = this.isArchived;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isKeySeniorEmployee"] = this.isKeySeniorEmployee;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IApplicationUserDto {
    id?: string;
    userName?: string | undefined;
    email?: string | undefined;
    fullName?: string | undefined;
    isActive?: boolean;
    isArchived?: boolean;
    createdAt?: Date | undefined;
    isKeySeniorEmployee?: number;
    roles?: string[];
}

export class CreateSystemUserCommand implements ICreateSystemUserCommand {
    email!: string;
    fullName?: string | undefined;
    roles?: string[];

    constructor(data?: ICreateSystemUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSystemUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSystemUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface ICreateSystemUserCommand {
    email: string;
    fullName?: string | undefined;
    roles?: string[];
}

export class UpdateSystemUserRequest implements IUpdateSystemUserRequest {
    email?: string;
    fullName?: string | undefined;
    roles?: string[];

    constructor(data?: IUpdateSystemUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.fullName = _data["fullName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSystemUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSystemUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["fullName"] = this.fullName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateSystemUserRequest {
    email?: string;
    fullName?: string | undefined;
    roles?: string[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}